import {
  FiAlertCircle as RawFiAlertCircle,
  FiAlignLeft as RawFiAlignLeft,
  FiArchive as RawFiArchive,
  FiArrowDown as RawFiArrowDown,
  FiArrowLeft as RawFiArrowLeft,
  FiArrowRight as RawFiArrowRight,
  FiArrowUp as RawFiArrowUp,
  FiCalendar as RawFiCalendar,
  FiCheck as RawFiCheck,
  FiCheckCircle as RawFiCheckCircle,
  FiCheckSquare as RawFiCheckSquare,
  FiChevronDown as RawFiChevronDown,
  FiChevronLeft as RawFiChevronLeft,
  FiChevronRight as RawFiChevronRight,
  FiCircle as RawFiCircle,
  FiClock as RawFiClock,
  FiCopy as RawFiCopy,
  FiExternalLink as RawFiExternalLink,
  FiHelpCircle as RawFiHelpCircle,
  FiImage as RawFiImage,
  FiLink2 as RawFiLink2,
  FiLock as RawFiLock,
  FiLogOut as RawFiLogOut,
  FiMenu as RawFiMenu,
  FiMessageCircle as RawFiMessageCircle,
  FiMoreHorizontal as RawFiMoreHorizontal,
  FiMove as RawFiMove,
  FiPaperclip as RawFiPaperclip,
  FiPlus as RawFiPlus,
  FiSearch as RawFiSearch,
  FiSettings as RawFiSettings,
  FiShield as RawFiShield,
  FiStar as RawFiStar,
  FiTag as RawFiTag,
  FiTrash2 as RawFiTrash2,
  FiUser as RawFiUser,
  FiUserPlus as RawFiUserPlus,
  FiUsers as RawFiUsers,
  FiX as RawFiX,
} from 'react-icons/fi';
import type * as React from 'react';

type FiIconComponent = (props: any) => React.JSX.Element;

const asFiIcon = (icon: unknown): FiIconComponent => icon as FiIconComponent;

export const FiAlertCircle = asFiIcon(RawFiAlertCircle);
export const FiAlignLeft = asFiIcon(RawFiAlignLeft);
export const FiArchive = asFiIcon(RawFiArchive);
export const FiArrowDown = asFiIcon(RawFiArrowDown);
export const FiArrowLeft = asFiIcon(RawFiArrowLeft);
export const FiArrowRight = asFiIcon(RawFiArrowRight);
export const FiArrowUp = asFiIcon(RawFiArrowUp);
export const FiCalendar = asFiIcon(RawFiCalendar);
export const FiCheck = asFiIcon(RawFiCheck);
export const FiCheckCircle = asFiIcon(RawFiCheckCircle);
export const FiCheckSquare = asFiIcon(RawFiCheckSquare);
export const FiChevronDown = asFiIcon(RawFiChevronDown);
export const FiChevronLeft = asFiIcon(RawFiChevronLeft);
export const FiChevronRight = asFiIcon(RawFiChevronRight);
export const FiCircle = asFiIcon(RawFiCircle);
export const FiClock = asFiIcon(RawFiClock);
export const FiCopy = asFiIcon(RawFiCopy);
export const FiExternalLink = asFiIcon(RawFiExternalLink);
export const FiHelpCircle = asFiIcon(RawFiHelpCircle);
export const FiImage = asFiIcon(RawFiImage);
export const FiLink2 = asFiIcon(RawFiLink2);
export const FiLock = asFiIcon(RawFiLock);
export const FiLogOut = asFiIcon(RawFiLogOut);
export const FiMenu = asFiIcon(RawFiMenu);
export const FiMessageCircle = asFiIcon(RawFiMessageCircle);
export const FiMoreHorizontal = asFiIcon(RawFiMoreHorizontal);
export const FiMove = asFiIcon(RawFiMove);
export const FiPaperclip = asFiIcon(RawFiPaperclip);
export const FiPlus = asFiIcon(RawFiPlus);
export const FiSearch = asFiIcon(RawFiSearch);
export const FiSettings = asFiIcon(RawFiSettings);
export const FiShield = asFiIcon(RawFiShield);
export const FiStar = asFiIcon(RawFiStar);
export const FiTag = asFiIcon(RawFiTag);
export const FiTrash2 = asFiIcon(RawFiTrash2);
export const FiUser = asFiIcon(RawFiUser);
export const FiUserPlus = asFiIcon(RawFiUserPlus);
export const FiUsers = asFiIcon(RawFiUsers);
export const FiX = asFiIcon(RawFiX);
